import { Component, OnInit, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchService } from '../search/search.component.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})

export class SearchComponent implements OnInit {
  private baseUrl = "https://v1-sneakers-test.p.rapidapi.com/sneakers?limit=100";
  public gender="male";
  public brand = "New Balance";
  public searchTerm = "";
  public fullUrl = "https://v1-sneakers-test.p.rapidapi.com/sneakers?limit=100&brand=New+Balance&gender=men";
  public results = [];
  public favorites = [];
  public resultsAreEmpty = false;

  constructor(private http: HttpClient, private searchService: SearchService) { }

  ngOnInit(): void {
    this.results = this.searchService.getResults();
  }

  async onSubmit(form: any)
  {
    let fullUrl = this.getFullUrl(form.brands, form.gender, form.searchTerm);

    await this.searchService.setResultsByUrl(fullUrl);
    this.results = this.searchService.getResults();

    if(this.results.length < 1)
    {
      this.resultsAreEmpty = true;
    }
    else
    {
      this.resultsAreEmpty = false;
    }
  }

  clearResults()
  {
    console.log("Clear");
    this.searchService.clearResults();
    this.results = this.searchService.getResults();
  }

  getFullUrl(brand, gender, keyword):string
  {
    let fullUrl = "";
    let paramUrl = "";
    let baseUrl = this.baseUrl;

    paramUrl = "&brand=" + brand.replace(/\s/g, '+');
    
    if(gender == "male")
    {
      paramUrl += "&gender=men";
    }
    else
    {
      paramUrl += "&gender=women";
    }

    if(keyword !== "")
    {
      paramUrl += "&name=" + keyword.replace(/\s/g, '+');
    }

    fullUrl = baseUrl + paramUrl;
    console.log(fullUrl);
    this.fullUrl = fullUrl;
    return fullUrl;
  }
}